import Vue from 'vue';
let thisVue = new Vue()

const state = {
    products: [],
    productsLabels: [],
    extras: [],
    extrasLabels: [],
    resources: [],
    resourcesLabels: [],
    categories: [],
    categoriesLabels: [],
    events: [],
    selectedItem: null,
    clonedItem: null,
    isAddingItem: false,
    productEditPriceData: null,
    isLoadingProducst: false,
    isLoadingExtras: false,
    isLoadingResources: false,
    isLoadingCategories: false,

    // ------ separation of items -> avoid using getSelectedItem for extras/servieces, products, etc
    selectedExtra: null,
};

const getters = {
    getProducts: (state) => state.products,
    getProductsLabels: (state) => state.productsLabels,
    getExtras: (state) => state.extras,
    getExtrasLabels: (state) => state.extrasLabels,
    getResources: (state) => state.resources,
    getResourcesLabels: (state) => state.resourcesLabels,
    getCategories: (state) => state.categories,
    getCategoriesLabels: (state) => state.categoriesLabels,
    getEvents: (state) => state.events,
    getEventsLabels: (state) => state.eventsLabels,
    getSelectedItem: (state) => state.selectedItem,
    getSelectedExtra: (state) => state.selectedExtra,
    getClonedItem: (state) => state.clonedItem,
    getProductEditPriceData: (state) => state.productEditPriceData,
    getPickupRoutes: (state) => state.pickupRoutes,
    getLoadingProducts: (state) => state.isLoadingProducst,
    getLoadingExtras: (state) => state.isLoadingExtras,
    getLoadingResources: (state) => state.isLoadingResources,
    getLoadingCategories: (state) => state.isLoadingCategories,
};

const actions = {
    async initProducts ({ dispatch, commit, getters, rootState }, data) {
        try {
            state.isLoadingProducst = true
            let response = await axios.get('/api/inventory/ListProduct', { params: { supplierId: rootState.user.account.supplierId }});
            state.isLoadingProducst = false
            if (response && response.status === 200 && response.data) {
                commit('INIT_PRODUCTS', {
                    products: response.data,
                    labels: {
                        name: 'Name',
                        code: 'Code',
                        category: 'Category',
                        // duration: 'Duration',
                        // capacity: 'Capacity',
                        // active: 'Active',
                    }
                });

                return true;
            }

            return false;
        }
        catch (error) {
            //Vue.toasted.error(error);
        }
    },

    async initCategories({ commit, rootState, dispatch }) {
        try {
            state.isLoadingCategories = true
            let response = await axios.get('/api/inventory/ListCategory', { params: { supplierId: rootState.user.account.supplierId }});
            state.isLoadingCategories = false

            if (response && response.status === 200 && response.data) {
                commit('INIT_CATEGORIES', {
                    categories: response.data,
                    labels: {
                        name: 'Name',
                        // description: 'Description',
                        // status: 'Status',
                    }
                });

                return true;
            }

            return false;
        }
        catch (error) {
            //Vue.toasted.error(error);
        }
    },

    async initResources ({ commit, rootState, dispatch }) {
        try {
            state.isLoadingResources = true
            let response = await axios.get('/api/inventory/ListResource', { params: { supplierId: rootState.user.account.supplierId }});
            state.isLoadingResources = false

            if (response && response.status === 200 && response.data) {
                commit('INIT_RESOURCES', {
                    resources: response.data,
                    labels: {
                        name: 'Name',
                        code: 'Code',
                        availability: 'Availability',
                        isActive: 'Status',
                    }
                });

                return true;
            }

            return false;
        }
        catch (error) {
            //Vue.toasted.error(error);
        }
    },

    async initExtras ({ commit, rootState, dispatch }) {
        try {
            state.isLoadingExtras = true
            let response = await axios.get('/api/inventory/ListExtra', { params: { supplierId: rootState.user.account.supplierId }});
            state.isLoadingExtras = false

            if (response && response.status === 200 && response.data) {
                commit('INIT_EXTRAS', {
                    extras: response.data,
                    labels: {
                        name: 'Name',
                        code: 'Code',
                        description: 'Description',
                        priceTotal: 'Price',
                        isActive: 'Status'
                    }
                });

                return true;
            }

            return false;
        }
        catch (error) {
            //Vue.toasted.error(error);
        }
    },

    // Initializes a list of events between dates.from and dates.to
    // (in YYYY-MM-DD format)

    async initEvents({ commit, rootState, dispatch }, dates) {
        try {
            let response = null;

            // Fetch events:
            // If we are on this modal window and we have a selected reservation,
            // this means we're rescheduling that same reservation, so we must
            // fetch similar events. Otherwise, we're adding a new, blank reservation
            // and we need to fetch ALL events.

            if (rootState.reservations.selectedReservation && rootState.reservations.selectedReservation.id !== undefined) {
                console.log('initting events with rootState.reservations.selectedReservation = ', rootState.reservations.selectedReservation)
                response = await axios.get('api/calendar/GetEventsToReschedule', { params: {
                    supplierId: rootState.user.account.supplierId,
                    bookingId: rootState.reservations.selectedReservation.id,
                    dateFrom: dates.from,
                    dateTo: dates.to
                }});
            }
            else {
                console.log('initting events without selectedReservation')

                response = await axios.get('api/calendar/GetEvents', { params: {
                    supplierId: rootState.user.account.supplierId,
                    dateFrom: dates.from,
                    dateTo: dates.to
                }});
            }

            if (response && response.status === 200 && response.data) {
                commit('INIT_EVENTS', response.data.events);
                return true;
            }

            return false;
        }
        catch (error) {
            //Vue.toasted.error(error);
        }
    },

    // Initializes the events retrieved externally

    commitEvents: ({ commit }, events) => {
        commit('INIT_EVENTS', events);
    },

    // Adds an item (placebo for update method)
    // Parameters: { action: 'edit', object: 'category', table: 'categories', fields: { object } }

    addItem: ({ dispatch, rootState }, data) => {
        //mixpanel
        thisVue.$ma.trackEvent({action: data.action + ' ' + data.object})

        //dispatch('closeModal');
        return new Promise((resolve, reject) => {
            dispatch('startFullScreenLoading');
            dispatch('updateItem', data).then((response) => {
                dispatch('stopFullScreenLoading');
                resolve(response);
            }).catch(function(error) {
                dispatch('stopFullScreenLoading');
                //Vue.toasted.error(error);
                reject(error);
            });
        })
    },

    updateItem: ({ commit, dispatch, state }, data) => {
        if (!data.object || !data.action) {
            throw new Error('Invalid object or action on updateItem');
        }

        let object = data.object.charAt(0).toUpperCase() + data.object.slice(1);
        let action = data.action.charAt(0).toUpperCase() + data.action.slice(1);
        let pluralTable = data.table.charAt(0).toUpperCase() + data.table.slice(1);

        if(!state.isAddingItem){
            state.isAddingItem = true;

            return new Promise((resolve, reject) => {
                dispatch('startFullScreenLoading');
                axios.post('/api/inventory/' + action + object, data.fields).then((response) => {
                    state.isAddingItem = false;
                    dispatch('stopFullScreenLoading');
                    if (response && response.status === 200) {
                        dispatch('init' + pluralTable);
                        // dispatch('clearSelectedItem');
                        dispatch('closeModal');

                        Vue.toasted.success(response.data.message);

                    }
                    resolve(response);
                    return response
                })
                .catch(function(error) {
                    dispatch('stopFullScreenLoading');
                    state.isAddingItem = false;
                    reject(error);
                    return error
                });
            })

        }
    },

    updateClonedItem: ({ commit }, fields) => {
        commit('UPDATE_CLONED_ITEM', fields);
    },

    setSelectedItem: ({ commit }, data) => {
        commit('SET_SELECTED_ITEM', data);
    },

    setSelectedExtra: ({ commit }, data) => {
        commit('SET_SELECTED_EXTRA', data);
    },

    setSelectedProduct: ({ commit }, data) => {
        commit('SET_SELECTED_PRODUCT', data);
    },

    clearSelectedItem: ({ commit }) => {
        console.log('clearSelectedItem dispatched');
        commit('CLEAR_SELECTED_ITEM');
    },
    clearSelectedExtra: ({ commit }) => {
        commit('CLEAR_SELECTED_EXTRA');
    },

    clearClonedItem: ({ commit }) => {
        console.log('clearClonedItem dispatched');
        commit('CLEAR_CLONED_ITEM');
    },

    pushEvent: ({ dispatch, commit, getters }, event) => {
        commit('SET_EVENT', event);
    },

    updateroductEditPriceData: ({state, commit}, payload) => {
        console.log('commit payload');
        console.log(payload);
        commit('UPDATE_EDIT_PRICE_DATA', payload);
    },

    addRouteToPickups: ({state}, payload) => {
        state.pickupRoutes.push(payload);
    }
}

const mutations = {
    INIT_PRODUCTS: (state, data) => {
        state.products = data.products;
        state.productsLabels = data.labels;
    },

    INIT_EXTRAS: (state, data) => {
        state.extras = data.extras;
        state.extrasLabels = data.labels;
    },

    INIT_RESOURCES: (state, data) => {
        state.resources = data.resources;
        state.resourcesLabels = data.labels;
    },

    INIT_CATEGORIES: (state, data) => {
        state.categories = data.categories;
        state.categoriesLabels = data.labels;
    },

    INIT_EVENTS: (state, events) => {
        state.events = events;
    },

    SET_SELECTED_ITEM: (state, data) => {
        state.selectedItem = (data.id !== undefined) ? state[data.table].find(i => i.id === data.id) : null;
    },

    SET_SELECTED_EXTRA: (state, data) => {
        state.selectedExtra = data;
    },

    SET_SELECTED_PRODUCT: (state, data) => {
        state.selectedItem = data;
    },

    CLEAR_SELECTED_ITEM: (state) => {
        state.selectedItem = null;
    },

    CLEAR_SELECTED_EXTRA: (state) => {
        state.selectedExtra = null;
    },

    CLEAR_CLONED_ITEM: (state) => {
        state.clonedItem = null;
    },

    UPDATE_CLONED_ITEM: (state, fields) => {
        state.clonedItem = fields;
    },

    SET_EVENT: (state, e) => {
        var exists = e.id ? state.events.find(evt => evt.id === e.id) : null;

        if (exists &&_.indexOf(state.events, exists) == -1) {
            console.log('Error while appending new event!');
            return false;
        }
        else {
            // Add the new event and update the data (including id, etc.).
            // Currently randomizing an id for test purposes

            e.id = Math.floor(Math.random() * (30 - 12300)) + 12300;
            e.notes = [];
        }

        state.events.splice(state.events.length, 1, e);
    },

    SET_NOTE: (state, data) => {
        var e = state.events.find(evt => evt.id === data.event.id);

        if (e) {
            // Random id for now

            data.note.id = Math.floor(Math.random() * (30 - 12300)) + 12300;
            e.notes.splice(e.notes.length, 1, data.note);
        }
    },

    UPDATE_EDIT_PRICE_DATA: (state, payload) => {
        state.productEditPriceData = payload
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/inventory.js